/* eslint-disable */

<template>
    <BaseDialog 
        :max_width="`80%`"
        :dialog="dialog"
        title="Nuovo reparto"
        v-on:close_dialog="closeDialog">
            <v-form v-model="valid" ref="depForm">
                <div class="d-flex">
                <v-text-field dense outlined
                    v-model="c_department.name"
                    label="nome"
                    required
                    :rules="[rules.nameRules, rules.mandatory]"
                ></v-text-field>    
                <v-text-field dense outlined
                    class="pl-2"
                    label="note"
                    v-model="c_department.desc"
                ></v-text-field>
                <v-autocomplete dense outlined
                    class="pl-2"
                    label="contatti"
                    v-model="c_department.contacts"
                    :items="contacts"
                    item-text="name"
                    item-value="id"
                    multiple
                    small-chips
                    :rules="[rules.mandatory]"
                ></v-autocomplete>
                </div>
            </v-form>
        <template v-slot:action>
            <div class="d-flex align-center justify-center my-4">
                <v-btn color="primary" :disabled="!valid" @click="addDepartment">salva</v-btn>
                <v-btn class="ml-2" text @click="closeDialog">annulla</v-btn>
            </div>
        </template>        
    </BaseDialog>
</template>
<script>
import {getModel} from '../../utils/model'
// import _ from 'lodash'
import { f_rules } from '../../utils/commonUtils'
import BaseDialog from '../../components/dialogs/BaseDialog'

export default {
    components: {BaseDialog},
    props: [ "location_id", "contacts"],
    data() {
        return {
            c_department: {},
            dialog: false,
            rules: f_rules,
            valid: false
        }
    },
    mounted(){
        let Department = getModel("Department") 
        this.c_data = Department()
    },
    methods: {
        openDialog() {
            this.dialog = true
            this.$refs.depForm.reset()
        },
        async addDepartment() {
            let location = await this.$store.state.$pouch.get("registry", this.location_id)
            this.c_department.id = new Date().getTime().toString()
            location.departments[this.c_department.id] = this.c_department
            location.updated_by = this.$store.state.user._id
            location.updated = (new Date()).getTime()
            try {
                let res = await this.$store.state.$pouch.put('registry', location)
                if (res.ok) {
                    console.log("Update location " , res)
                    this.$emit("add_department", this.c_department)
                    this.closeDialog()
                }
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.dialog = false;
        }
    }
}
</script>